import { render, staticRenderFns } from "./GuardNav.vue?vue&type=template&id=605cdc06&scoped=true&"
import script from "./GuardNav.vue?vue&type=script&lang=js&"
export * from "./GuardNav.vue?vue&type=script&lang=js&"
import style0 from "./GuardNav.vue?vue&type=style&index=0&id=605cdc06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605cdc06",
  null
  
)

export default component.exports